import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const WatchProductions = React.lazy(
  () => import('components/WatchProductions/WatchProductions'),
);

export function ScreensWatchProductions() {
  const hasWatchProductionsEnabled = useFeatureFlagEnabled(
    'WatchProductionsSearch',
  );

  if (hasWatchProductionsEnabled === false) {
    return <Navigate to="/" replace />;
  }

  if (hasWatchProductionsEnabled === undefined) {
    return (
      <BaseLayout>
        <UILoader />
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <DocumentTitle>Watch Productions</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <WatchProductions />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensWatchProductions;
